import {FetchResult} from "apollo-link"
import getMessageFromErrorCode from "../../helpers/getMessageFromErrorCode"
import {headers} from "../../constants/headers"
import getDataFromError from "../../helpers/getDataFromError"
import {logErrorToIntercom} from "./logErrorToIntercom"

export function getGraphError(errors: FetchResult["errors"], operationName?: string): GraphError {
  const err = (errors?.[0] ?? {}) as unknown as GraphError

  // this shouldn't be hit as the caller should be passing in errors
  if (!err) throw new Error("Something went wrong!")

  const e = new Error() as GraphError
  e.apiError = err?.apiError
  e.errorCode = err?.errorCode ?? "Network Error"
  e.message = getMessageFromErrorCode(e.errorCode, err)
  e.traceId =
    e.apiError?.request?.headers?.[headers.correlationId] ||
    e.apiError?.request?.headers?.[headers.xAmzRequestId] || // not sure if this is still used
    null
  e.errorData = getDataFromError(err, e.traceId, e.errorCode)
  e.response = err.response
  e.operationName = operationName

  try {
    logErrorToIntercom({
      errorCode: e.errorCode,
      errorData: e.errorData,
      traceId: e.traceId,
      operationName: e.operationName
    })
  } catch (error) {
    /* no-op */
  }

  return e
}
